/**
 * ReviewSummaryBar — live accepted counter + Accept all / Reject all.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Sparkles } from 'lucide-react';

import { Button } from '@/components/ui';

export interface ReviewSummaryBarProps {
  accepted: number;
  total: number;
  onAcceptAll: () => void;
  onRejectAll: () => void;
}

const ReviewSummaryBar: FC<ReviewSummaryBarProps> = ({
  accepted,
  total,
  onAcceptAll,
  onRejectAll,
}) => (
  <div className="flex items-center gap-2 rounded-md border border-border/60 bg-muted/20 px-2.5 py-1.5">
    <Sparkles className="h-3.5 w-3.5 text-primary" aria-hidden />
    <span className="text-xs font-medium">
      Accepted <span className="tabular-nums">{accepted}</span> of{' '}
      <span className="tabular-nums">{total}</span>
    </span>
    <span className="ml-auto flex items-center gap-1">
      <Button variant="ghost" size="sm" className="h-6 px-2 text-[11px]" onClick={onAcceptAll}>
        Accept all
      </Button>
      <Button variant="ghost" size="sm" className="h-6 px-2 text-[11px]" onClick={onRejectAll}>
        Reject all
      </Button>
    </span>
  </div>
);

export default ReviewSummaryBar;
